/* eslint-disable */
import React, { useEffect, memo } from 'react'
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import { makeStyles, ThemeProvider, createTheme } from '@material-ui/core'
import { useAppSelector, useAppDispatch } from '../app/hooks'
import { handleChange } from '../app/formSlice'
import styles from './assets/styles/textInput.styles'

export const theme = createTheme({
    palette: {
        primary: {
            main: '#101010'
        }
    }
})

const useStyles = makeStyles(styles)

const addValidation = () => {
    ValidatorForm.addValidationRule('isText', value => {
        return /^[a-z '-]+$/i.test(value.toString().trim())
    })
    ValidatorForm.addValidationRule('isEmail', value => {
        return /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value.toString().trim())
    })
}

function TextInput({
    validationType,
    validate,
    label,
    fullWidth,
    name,
    placeholder,
    multiLine,
    validationMessage
}) {
    const props = {
        fullWidth
    }
    const preserveMultiline = { whiteSpace: 'pre-wrap' }
    const classes = useStyles(props)
    const value = useAppSelector(state => state.form[name])
    const dispatch = useAppDispatch()
    const setValue = e => {
        dispatch(handleChange({
            name: e.target.name,
            value: e.target.value
        }))
    }
    useEffect(() => {
        if (validate) addValidation()
    }, [])
    const validateOptions = validate ? ['required', validationType] : ['required']
    const validateMessages = validate ? ['Necessario', validationMessage] : ['Necessario']
    return (
        <div className={classes.root} >
            <ThemeProvider theme={theme}>
                <span className={classes.span} >
                    <p className={classes.label} >{label} *</p>
                    <TextValidator
                        multiline={multiLine}
                        style={multiLine ? preserveMultiline : {}}
                        name={name}
                        fullWidth
                        required
                        onChange={setValue}
                        value={value}
                        placeholder={placeholder}
                        rows={multiLine ? 5 : 1}
                        InputProps={{
                            disableUnderline: true,
                            className: classes.fontFamily
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                        className={classes.input}
                        validators={validateOptions}
                        errorMessages={validateMessages}
                    />
                </span>
            </ThemeProvider>
        </div>
    )
}

export default memo(TextInput)
